<div class="background-image"></div>

  <div class="d-flex justify-content-center align-items-center" style="height: 100vh;" data-bs-theme="auto">
    <div class="p-4 rounded w-100" style="max-width: 700px;">
      <h2 class="mb-3 middle-text">{{ 'Passwort zurücksetzen' | translate }}</h2>
      <form class="auth-input p-5" [formGroup]="form" (ngSubmit)="onSubmit()">
        <p class="fs-18 text-white">Bitte geben Sie hier Ihr neues Passwort ein.</p>

        <div class="mb-5">
          <label class="form-label text-white">{{ 'USERS.PASSWORD' | translate }}</label>
          <p-password
            formControlName="password"
            inputValidator
            [toggleMask]="true"
            [feedback]="false"
            inputStyleClass="form-control"
            styleClass="w-100"
            autocomplete="new-password"
            [style]="{ color: '#fff' }"
          ></p-password>
        </div>
        <div class="mb-5">
          <label class="form-label text-white">{{ 'Passwort wiederholen' | translate }}</label>
          <p-password
            formControlName="password_confirmation"
            inputValidator
            [toggleMask]="true"
            [feedback]="false"
            inputStyleClass="form-control"
            styleClass="w-100"
            autocomplete="new-password"
          ></p-password>
        </div>
        <div class="d-grid mb-3">
          <p-button
            styleClass="btn btn-primary"
            type="submit"
            [label]="'Absenden' | translate"
            [loading]="isLoading"
            [disabled]="isLoading"
          ></p-button>
        </div>
      </form>
    </div>
  </div>



